export const donateButtonSx = {
  position: 'fixed',
  bottom: '20px',
  right: '20px',
  zIndex: 20000,
};
